/* !
 * webmagazine v1.0.0
 * Copyright 2024, Connecty Inc.
 */
(($, THERMOS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const o = 'is-open';
	const $map = THERMOS.va.pathname.split('/');

	// [WEBMAGAZINEトップ] MVカルーセル
	const arrowPath = 'M12,40.1c-1,0-2-.4-2.9-1.2-1.6-1.6-1.6-4.1,0-5.7l13.2-13.2L9.1,6.8c-1.6-1.6-1.6-4.1,0-5.7s4.1-1.6,5.7,0l16.1,16.1c1.6,1.6,1.6,4.1,0,5.7l-16.1,16.1c-.8.8-1.8,1.2-2.9,1.2h0Z';
	const topMVSlider = () => {
		let splide_mv = new Splide('.webmagazine-top-mainVis.splide', {
			type: 'loop',
			arrows: true,
			arrowPath: arrowPath,
			pagination: true,
			paginationKeyboard: true,
			speed: 1500,
			autoplay: true,
			interval: 5000,
			pauseOnHover: false,
			autoWidth: true,
			gap: '40px',
			focus: 'center',
			breakpoints: {
				768: {
					gap: '8px',
					autoWidth: false,
					padding: { left: '20px', right: '20px' }
				},
			}
		});
		splide_mv.mount();
	};

	// [WEBMAGAZINEトップ] POPULAR カルーセル
	const topPopularSlider = () => {
		let splide_mv = new Splide('.webmagazine-top-popularSlider.splide', {
			type: 'slide',
			arrows: false,
			pagination: false,
			paginationKeyboard: false,
			drag: false,
			speed: 1500,
			autoplay: false,
			pauseOnHover: false,
			perPage: 3,
			gap: '40px',
			focus: 'left',
			breakpoints: {
				768: {
					type: 'loop',
					autoplay: true,
					interval: 5000,
					drag: true,
					gap: '30px',
					autoWidth: true,
					padding: { left: '20px', right: '20px' }
				},
			}
		});
		splide_mv.mount();
	};

	// カテゴリリンクプルダウン（SPのみ）
	const pulldown = () => {
		const setPulldown = (_e, _ele, _summary, _content, _h) => {
			const option = { duration: 300, easing: 'ease', fill: 'forwards' };
			const option_content = { duration: 300, easing: 'ease' };

			if (_e) { _e.preventDefault(); }

			if (_ele.open) {
				const close = _content.animate({
					opacity: [1, 0],
					height: [_content.offsetHeight + 'px', 0],
				}, option_content);

				_ele.animate({ height: [(_summary.offsetHeight + _content.offsetHeight + 3) + 'px', _h] }, option);

				close.onfinish = () => {
					_ele.removeAttribute('open');
				}
			} else {
				_ele.setAttribute('open', 'true');
				_ele.animate({ height: [_h, (_summary.offsetHeight + _content.offsetHeight + 3) + 'px'] }, option);

				_content.animate({
					opacity: [0, 1],
					height: [0, _content.offsetHeight + 'px'],
				}, option_content);
			}
		};
		const detail = document.querySelector('.__keywordList > details');

		if (THERMOS.va.window.width < THERMOS.va.device.desktop) {
			const summary = detail.querySelector('summary');
			const content = detail.querySelector('.__select_content');
			let h = detail.offsetHeight + 'px';
			summary.addEventListener('click', e => {
				setPulldown(e, detail, summary, content, h);
			});

			document.addEventListener('click', e => {
				if (!e.target.closest('.__keywordList')) {
					if (detail.open) {
						setPulldown(false, detail, detail.querySelector('summary'), detail.querySelector('.__select_content'), detail.closest('.__keywordList').offsetHeight + 'px')
					}
				}
			});
		} else {
			detail.setAttribute('open', true);
		}
	};

	// [WEBMAGAZINEトップ] サイト内記事検索を開く
	const siteSearch = () => {
		const keywordSearch = document.querySelector('.__keywordSearch');
		const searchSwitch = document.querySelector('.__keywordSearch .__switch');
		const keywordList = document.querySelector('.__keywordList');
		searchSwitch.addEventListener('click' , () => {
			if (keywordSearch.classList.contains(a)) {
				keywordList.classList.remove(o);
				searchSwitch.classList.remove(a);
				keywordSearch.classList.remove(v);
				setTimeout(() => { keywordSearch.classList.remove(a); }, 300);
			} else {
				keywordList.classList.add(o);
				searchSwitch.classList.add(a);
				keywordSearch.classList.add(a);
				setTimeout(() => { keywordSearch.classList.add(v); });
			}
		});

		// webmagazine配下で絞り込んだgoogle siteseatchを開く
		let URL = 'www.thermos.jp/webmagazine';
		$('.js-webmagazineSearch-submit').on('click', (e) => {
			if ($(e.currentTarget).prev('.js-webmagazineSearch-input').val()) {
				window.open(
					`https://www.google.co.jp/search?sitesearch=${URL}&q=${encodeURIComponent($(e.currentTarget).prev('.js-webmagazineSearch-input').val())}`,
					'_blank',
					'location,status,menubar,toolbar,scrollbars,resizable,noopener'
				);
			} else {
				window.open('https://www.google.co.jp/search?sitesearch=${URL}', '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
			}
		});
		$('.js-webmagazineSearch-input').on('keydown', (e) => {
			if (e.keyCode === 13) {
				if ($(e.currentTarget).val()) {
					window.open(
						`https://www.google.co.jp/search?sitesearch=${URL}&q=${encodeURIComponent($(e.currentTarget).val())}`,
						'_blank',
						'location,status,menubar,toolbar,scrollbars,resizable,noopener'
					);
				} else {
					window.open('https://www.google.co.jp/search?sitesearch=${URL}', '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
				}
			}
		});
	};

	if (document.querySelector('.webmagazine-top-mainVis')) {
		topMVSlider();
		pulldown();
		topPopularSlider();
		siteSearch();
	}

	// ------------------------------------------------------------------------------------------
	// [記事詳細] JSON-LD
	const setJsonLD = () => {
		if (location.pathname === '/webmagazine/article/detail/20220725101845.html' ||
				location.pathname === '/webmagazine/article/detail/20220516170232.html' ||
				location.pathname === '/webmagazine/article/detail/20220314115005.html' ||
				location.pathname === '/webmagazine/article/detail/20210310090035.html' ||
				location.pathname === '/webmagazine/article/detail/20220218195721.html' ||
				location.pathname === '/webmagazine/article/detail/20220519154841.html') {
			let mainImg = document.querySelector('.webmagazine-detail-mainVis img').getAttribute('src');
			if (mainImg.slice(0, 1) === '.') {
				mainImg = mainImg.slice(1);
			}
			let appendSrc = '{ "@context": "https://schema.org", "@type": "Article",' +
				`"headline": "${document.querySelector('h1.rt_cf_n_title_str').textContent}",` +
				`"image": [ "https://www.thermos.jp${mainImg}" ],` +
				`"datePublished":"${document.querySelector('.webmagazine-bgHead .webmagazine-date').getAttribute('datetime')}",` +
				`"author": { "@type": "Person", "name": "${document.querySelector('.article-detail-person-name').textContent}"`;

			if (document.querySelector('.article-detail-person .article-detail-a')) {
				appendSrc += `, "url": "${document.querySelector('.article-detail-person .article-detail-a').getAttribute('href')}"`;
			}
			appendSrc += '}}';
			document.querySelector('.jsonld-script').innerHTML = appendSrc;
		}
	};

	// [記事詳細] 最近見た記事に追加
	const addRecentStorage = (_thisCode) => {
		var watchDatetime = new Date();
		watchDatetime = `${watchDatetime.getFullYear()}/${('0' + (watchDatetime.getMonth() + 1)).slice(-2)}/${(('0' + (watchDatetime.getDate())).slice(-2))} ` +
			`${('0' + (watchDatetime.getHours())).slice(-2)}:${('0' + (watchDatetime.getMinutes())).slice(-2)}:${('0' + (watchDatetime.getSeconds())).slice(-2)}`;
		localStorage.setItem('recentArticleList-' + _thisCode, watchDatetime);
	}

	// [記事詳細] シェアボタン
	const setShareLinks = () => {
		document.querySelectorAll('.js-share-item').forEach(ele => {
			const url = encodeURIComponent(document.URL);
			const title = encodeURIComponent(document.title);
			const href = ele.getAttribute('href').replace(/#link/ig, url).replace(/#text/ig, title);
			ele.setAttribute('href', href);
		});
	};

	// [記事詳細] おすすめの商品
	const createRecommendProd = () => {
		if (document.querySelectorAll('.webmagazine-detail-recommend .rt_remark_str').length) {
			let promiseArr = [];
			let htmlList = [];
			document.querySelectorAll('.webmagazine-detail-recommend .rt_remark_str').forEach((ele, idx) => {
				let thisId = ele.textContent;
				if (thisId) {
					if (thisId.indexOf('series') !== -1) {
						// シリーズ指定の場合
						thisId = thisId.replace(/series /, '');

						let xhr = new XMLHttpRequest();
						let promise = new Promise((resolve, reject) => {
							fetch(`/ajax/webmagazine/article/product/series/${thisId}.json`).then(response => response.json()).then(data => {
								if (data) {
									if (data.rt_bn_product_series_info.length) {
										let seriesData = data.rt_bn_product_series_info[0];
										htmlList[idx] = `<li><figure><img src="${seriesData.rt_product_img.src}" alt="" loading="lazy" width="100" height="100">` +
											`<figcaption><p>${seriesData.rt_product_name.content[0]}</p>` +
											`<a href="/product/series/${thisId}.html" class="__link"><svg aria-hidden="true"><use href="/common/svg/sprite.svg#arrow_right" /></svg><span>製品を詳しく見る</span></a>`;
										if (seriesData.rt_cf_pse_ec_url) {
											htmlList[idx] += `<a href="${seriesData.rt_cf_pse_ec_url.href}" target="_blank" rel="noopener" class="mod-btn">` +
												`<svg aria-hidden="true" class="_iconLeft"><use href="/common/svg/sprite.svg#shop" /></svg>` +
												`<span>製品のご購入</span><svg aria-label="新しいウィンドウでサーモスオンラインショップを開きます"><use href="/common/svg/sprite.svg#blank"></use></svg></a>`;
										}
										htmlList[idx] += `</figcaption></figure></li>`;
									}
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							});
						});
						promiseArr.push(promise);
					} else {
						// 製品指定の場合
						let thisColor = thisId.split('_')[1];

						let xhr = new XMLHttpRequest();
						let promise = new Promise((resolve, reject) => {
							fetch(`/ajax/webmagazine/article/product/detail/${thisId}.json`).then(response => response.json()).then(data => {
								if (data) {
									if (data.rt_bn_product_info.length) {
										let prodData = data.rt_bn_product_info[0];
										htmlList[idx] = `<li><figure>` +
											`<img src="${prodData.rt_product_img.src}" alt="" loading="lazy" width="100" height="100">` +
											`<figcaption><p>${prodData.rt_product_name.content[0]}</p>` +
											`<p>${thisId.split('_')[0]}</p>`;

										if (thisColor) {
											htmlList[idx] += `<p>${prodData.rt_product_color_name.content[0]}</p>` +
												`<a href="${prodData.rt_product_href.href}?color=${thisColor}" class="__link">`;
										} else {
											htmlList[idx] += `<a href="${prodData.rt_product_href.href}" class="__link">`;
										}

										htmlList[idx] += `<svg aria-hidden="true"><use href="/common/svg/sprite.svg#arrow_right" /></svg><span>製品を詳しく見る</span></a>`;

										if (prodData.rt_cf_pse_ec_url) {
											htmlList[idx] += `<a href="${prodData.rt_cf_pse_ec_url.href}" target="_blank" rel="noopener" class="mod-btn">` +
												`<svg aria-hidden="true" class="_iconLeft"><use href="/common/svg/sprite.svg#shop" /></svg>` +
												`<span>製品のご購入</span><svg aria-label="新しいウィンドウでサーモスオンラインショップを開きます"><use href="/common/svg/sprite.svg#blank"></use></svg></a>`;
										}
										htmlList[idx] += `</figcaption></figure></li>`;
									}
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							});
						});
						promiseArr.push(promise);
					}
				} else {
					document.querySelector('.webmagazine-detail-recommend').remove();
				}
			});
			Promise.all(promiseArr).then(result => {
				let appendHTML = '';
				htmlList.forEach(ele => {
					appendHTML += ele;
				});
				document.querySelector('.js-recommendList').innerHTML = appendHTML;
			}).catch((error) => {
				console.error('AJAX ERROR');
			});
		} else {
			document.querySelector('.webmagazine-detail-recommend').remove();
		}
	}

	// 記事詳細
	if (document.querySelector('.webmagazine-detail')) {
		let thisID = $map[$map.length - 1].replace(/.html/g, '');
		addRecentStorage(thisID);

		setJsonLD();
		setShareLinks();
		createRecommendProd();
	}

	// ------------------------------------------------------------------------------------------
	// [共通] 最近見た記事 表示
	const getRecentArticle = () => {
		let thisID = $map[$map.length - 1].replace(/.html/g, '');

		if (document.querySelector('.js-recentList')) {
			let recentStorage = [], recentStorageNew = [];
			for (let i in localStorage) {
				if (i.indexOf('recentArticleList-') !== -1) {
					recentStorage.push({
						idx: i,
						datetime: localStorage[i]
					});
				}
			}
			if (recentStorage.length) {
				recentStorage.sort((x, y) => {
					let xDate = x['datetime'];
					let yDate = y['datetime'];
					if (xDate > yDate) return (-1);
					if (xDate < yDate) return 1;
					return 0;
				});
				for (let i = 0; i < recentStorage.length; i++) {
					if (i < 4) {
						recentStorageNew.push(recentStorage[i].idx);
					} else {
						// 4件以上は削除
						localStorage.removeItem(recentStorage[i].idx);
					}
				}
			}
			if (recentStorageNew.length > 1) {
				let promiseArr = [];
				let htmlList = [];
				let count = 0;
				recentStorageNew.forEach((ele, idx) => {
					let articleID = ele.replace(/recentArticleList-/, '');
					if ((document.querySelector('.webmagazine-detail') && articleID !== thisID) || (!document.querySelector('.webmagazine-detail') && count < 3)) {
						count++;
						let xhr = new XMLHttpRequest();
						let promise = new Promise((resolve, reject) => {
							fetch(`/ajax/webmagazine/article/detail/${articleID}.json`).then(response => response.json()).then(data => {
								if (data) {
									if (data.rt_bn_news_info.length) {
										let articleData = data.rt_bn_news_info[0];
										htmlList[idx] = `<li class="__column_3 __column_tab_1"><a href="${articleData.rt_cf_n_href.href}" class="__item"><figure>`;

										if (articleData.rt_cf_n_thum_img !== null) {
											htmlList[idx] += `<img src="${articleData.rt_cf_n_thum_img.src}" alt="" loading="lazy">`;
										} else {
											htmlList[idx] += '<img src="/images/webmagazine/dummy.webp" alt="" loading="lazy">';
										}
										htmlList[idx] += `<figcaption><p class="__caption">${articleData.rt_cf_n_title.content}</p>` +
											`<time class="webmagazine-date" datetime="${articleData.rt_cf_n_date.datetime}">${articleData.rt_cf_n_date.content}</time></figcaption></figure></a></li>`;
									}
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							});
						});
						promiseArr.push(promise);
					}
				});
				Promise.all(promiseArr).then(result => {
					let appendHTML = '';
					htmlList.forEach(ele => {
						appendHTML += ele;
					});
					document.querySelector('.js-recentList').innerHTML = appendHTML;
				}).catch((error) => {
					console.error('AJAX ERROR');
				});
			} else {
				document.querySelector('.webmagazine-recent').remove();
			}
		}
	};

	getRecentArticle();

})(window.jQuery, window.THERMOS);